import useLocalStorageState from './src/useLocalStorageState';
import createLocalStorageStateHook from './src/createLocalStorageStateHook';
export default useLocalStorageState;
export { useLocalStorageState, createLocalStorageStateHook };
